import {
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  ViewContainerRef
} from '@angular/core';
import {GnTableColumnConfig} from './TableColumnConfig';
import {tableColumnTypes} from './TableColumn';

@Directive({
  selector: '[gnCustomTableColumn]'
})
export class GnCustomTableColumnDirective {

  private component: ComponentRef<any>;
  private row: any;

  @Input('row') set setRow(value) {
    this.row = value;
    this.setComponentRow();
  }

  @Input('gnCustomTableColumn') set setColumnConfig(config: GnTableColumnConfig) {
    const columnType = tableColumnTypes[config.type];
    if (!columnType) {
      throw new Error(`表格列组件[${config.type}]未注册`);
    }
    const controlFactory: ComponentFactory<any> = this.resolver.resolveComponentFactory(columnType);
    this.component = this.container.createComponent(controlFactory);
    if (config.options) {
      for (const key of Object.keys(config.options)) {
        this.component.instance[key] = config.options[key];
      }
    }
    this.setComponentRow();
  }

  constructor(private resolver: ComponentFactoryResolver,
              private container: ViewContainerRef) {
  }

  private setComponentRow() {
    if (this.component) {
      this.component.instance.row = this.row;
    }
  }

}
